import * as React from 'react';
import { useDispatch } from 'react-redux';

import {
  getOffersHistory,
  openOfferFromHistory,
  setPage,
  setStatusFilter,
  setDefaultRooms,
  setDefaultCategory,
} from '../../../../actions/offersHistory';
import { mapOfferStatusEnums, FILTER_ALL_VALUE, TStatusFilterOptionValue } from '../../../../store/offerHistory';
import { trackFiltersChange } from '../analytics';

/**
 * Хендлер клика по фильтру статусов
 * */
export const useHandleStatusFiltersClick = () => {
  const dispatch = useDispatch();

  return React.useCallback(
    async (e: React.ChangeEvent, value: TStatusFilterOptionValue) => {
      dispatch(setDefaultRooms());
      dispatch(setDefaultCategory());

      dispatch(setStatusFilter(value === FILTER_ALL_VALUE ? FILTER_ALL_VALUE : mapOfferStatusEnums[value]));

      dispatch(setPage(1));
      await dispatch(getOffersHistory(false));
      dispatch(trackFiltersChange());
      await dispatch(openOfferFromHistory());
    },
    [dispatch],
  );
};
